import {createAction} from 'redux-actions';
import {actionTypes as system} from '../System';
import {handleActions} from '../../Utility/HandleActions';

//
// actionTypes
//
const TOGGLE = 'DBM/UI/MENU/TOGGLE';

//
// Create actions
//
const toggle = createAction(TOGGLE);

export const actionTypes = {
    TOGGLE
};

export const actions = {
    toggle
};

//
// Export reducer
//
export const reducer = handleActions({
    [system.INIT]: () => (state) => state.setIn(['ui', 'valueDateCalendar', 'isOpen'], false),

    [TOGGLE]: () => (state) => state.setIn(['ui', 'valueDateCalendar', 'isOpen'], !state.getIn(['ui', 'valueDateCalendar', 'isOpen']))
});

const isOpen = (state) => state.getIn(['ui', 'valueDateCalendar', 'isOpen']);


export const selectors = {
    isOpen
};
